
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return _createElement('div', { 'className': 'cm_garage' }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, _createElement('div', { 'className': 'garage-icon-container' }, _createElement('div', { 'className': 'garage-icon' }, _createElement('svg', {
        'width': '26',
        'height': '26',
        'viewBox': '0 0 40 40',
        'fill': 'currentColor',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', { 'd': 'M38.6,13.3h-4.3l-0.6-1.7c0-3.8-5.4-6.2-8.3-6.2H14.7c-2.9,0-8.3,2.8-8.5,6.7l-0.5,1.1H1.4c-0.4,0-0.7,0.3-0.7,0.7L1.4,16c0,0.4,0.3,0.7,0.7,0.7h2.6c-1.6,0.6-2.7,2.2-2.7,4v4.5c0,1,0.4,1.9,1,2.7V28v4.6c0,1,0.8,1.8,1.8,1.8h3.9c1,0,1.8-0.8,1.8-1.8v-3.1h19.3v3.1c0,1,0.8,1.8,1.8,1.8h3.9c1,0,1.8-0.8,1.8-1.8V28l0,0c0.6-0.7,1-1.7,1-2.7v-4.5c0-1.8-1.1-3.3-2.7-4h2.5c0.4,0,0.7-0.3,0.7-0.7l0.7-2.1C39.3,13.7,39,13.3,38.6,13.3z M9.6,15.7c1.3-3.6,3.4-5.8,5.7-5.8h10.1c2.2,0,4.6,2.7,5.2,6H9.5C9.5,15.7,9.6,15.7,9.6,15.7z M9.1,25.1H7.3c-1.3,0-2.4-1.1-2.4-2.4s1-2.4,2.3-2.4l0.5,0.1c1.6,0.1,3,1.7,3.1,2.7l0.1,0.7C10.8,25.1,10.3,25.1,9.1,25.1z M32.7,25.1h-1.8c-1.3,0-1.8,0-1.9-1.3l0.1-0.7c0.2-1,1.5-2.5,3.1-2.7l0.5-0.1c1.3,0,2.3,1.1,2.3,2.4C35.1,24,34,25.1,32.7,25.1z' }))), this.size ? _createElement('span', {
        'className': 'garage-size rpui-utility-link__badge',
        'key': '1078'
    }, this.size) : null), _createElement('span', { 'className': 'garage-label' }, _translate(`garage_title`))), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' }, _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, [_createElement('svg', {
                                'className': 'cm_icon cm_icon-times',
                                'height': '20px',
                                'role': 'img',
                                'viewBox': '0 0 22 22',
                                'key': '1930'
                            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, _createElement('div', {
                'className': 'clear-garage',
                'onClick': this.clearGarage
            }, _translate(`garage_clear`)), _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]), [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1402'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  button button--primary cm_addButton' }, [window.Convermax.config?.garageButtonText || _translate(`garage_add_button`)]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement('ul', {}, _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_one`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_two`)), _createElement('li', { 'className': 'vehicle-advantages' }, _translate(`garage_info_line_three`))))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]